import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, ShoppingBag, FileText, Building2, MapPin, MessageSquare, Briefcase } from "lucide-react";

const NAV = [
  { to: "/konts", end: true, icon: LayoutDashboard, label: "Pārskats" },
  { to: "/konts/pasutijumi", icon: ShoppingBag, label: "Mani pasūtījumi" },
  { to: "/konts/rekini", icon: FileText, label: "Rēķini" },
  { to: "/konts/rekviziti", icon: Building2, label: "Rekvizīti" },
  { to: "/konts/adreses", icon: MapPin, label: "Piegādes adreses" },
  { to: "/konts/sazina", icon: MessageSquare, label: "Saziņa ar menedžeri" },
  { to: "/konts/b2b", icon: Briefcase, label: "B2B rīki" },
];

export default function AccountLayout() {
  return (
    <div className="max-w-7xl mx-auto px-4 mt-6">
      <div className="mb-6">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight uppercase" data-testid="account-title">Klienta kabinets</h1>
        <p className="text-sm text-[#6B6B6B] mt-1">Demo uzņēmums SIA · B2B Zelta klients · Menedžeris: Anna Menedžere</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <aside>
          <nav className="flex lg:flex-col gap-1 overflow-x-auto pb-2 lg:pb-0">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} data-testid={`account-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) => `flex items-center gap-2.5 px-4 py-3 text-sm font-semibold whitespace-nowrap transition-colors ${isActive ? "bg-[#111111] text-white" : "bg-[#F5F5F5] hover:bg-[#E2E2E2]"}`}>
                <n.icon size={16} /> {n.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <div className="lg:col-span-3 min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
